// Fixed contract with the backend grid definition - do not rename.
export const CARIS_SERVICE_REQUEST_HISTORY_GRID_CODE = 'vehicle-caris-service-request-history';
